export enum DeliveryTimeType {
  ASAP = 'ASAP',
  Future = 'FutureOrder',
}

export interface DeliveryTime {
  type: DeliveryTimeType;
  requested_delivery_time?: string;
  requested_delivery_end_time?: string;
}

export type FutureOrderDateTimes = Omit<DeliveryTime, 'type'>;

export type TradingHoursReturnType = {
  label: string;
  value: string;
  isDisabled?: boolean;
};
